//------------------------------------------------//
//                                                //
//  Logic: Scroll logic.                          //
//                                                //
//------------------------------------------------//

export function scroll($) {

	//------------------------------------------------------
	// Scroll Status
	//------------------------------------------------------

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var minScroll = 50;

	function hasScrolled() {

		var st = $(window).scrollTop();

		// Make sure they scroll more than delta

		if(Math.abs(lastScrollTop - st) <= delta) {
			return;
		}

		if (st > lastScrollTop) {
			// Scroll Down
			$('body').removeClass('scrolled--up scrolled--totop').addClass('scrolled--down');
		} else {
			// Scroll Up
			$('body').removeClass('scrolled--down scrolled--totop').addClass('scrolled--up');
		}
		if (st < minScroll) {
			$('body').removeClass('scrolled--up scrolled--down').addClass('scrolled--totop');
		}
		lastScrollTop = st;

	}

	//------------------------------------------------------
	// Sticky column
	//------------------------------------------------------

	const elemSticky = $('.js--sticky');
	const stickySeparation = 50;

	function stickyColumn(elem) {
		if (!elem.length) return false;
		var st = $(window).scrollTop();
		var elemOffsetTop = elem.offset().top;
		var elemHeight = elem.children().outerHeight();
		var headerHeight = $('.header-menu').outerHeight();

		var siblingHeight = elem.prev().outerHeight();
		var siblingOffsetTop = elem.prev().offset().top;

		var bottomReach = (st + elemHeight + stickySeparation >= siblingHeight + siblingOffsetTop);

		var marginTop = (st >= elemOffsetTop - headerHeight - stickySeparation) ? st - elemOffsetTop + headerHeight + stickySeparation : 0;

		if (!bottomReach) {
			elem.children().css({
				'margin-top' : marginTop
			});
		}
	}

	stickyColumn(elemSticky);



	//----------------------------------------------------
	// ON SCROLL
	//----------------------------------------------------

	hasScrolled();

	$(window).scroll(function(){
		didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
					stickyColumn(elemSticky);
	        didScroll = false;
	    }
	}, 250);

}
